export const register = async (
  fullnameRg,
  usernameRg,
  emailRg,
  passwordRg,
  profile_picRg,
) => {
  const url = "https://moviesteamd.herokuapp.com/api/v1/user/register";
  const data = {
    fullName: fullnameRg,
    userName: usernameRg,
    email: emailRg,
    password: passwordRg,
    profile_pic: profile_picRg,
  };
  try {
    const response = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    });
    return response.json();
  } catch (error) {
    throw error;
  }
};

export const login = async (email, password) => {
  const url = "https://moviesteamd.herokuapp.com/api/v1/auth";
  const data = {
    email,
    password,
  };
  try {
    const response = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    });
    return response.json();
  } catch (error) {
    throw error;
  }
};

export const fetchAllUser = async token => {
  const url = "https://moviesteamd.herokuapp.com/api/v1/user";
  try {
    const response = await fetch(url, {
      method: "GET",
      headers: {
        Authorization: `Bearer $(token)`,
      },
    });
    return response.json();
  } catch (error) {
    throw error;
  }
};
